import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6907f1d7&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6907f1d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6907f1d7')) {
      api.createRecord('6907f1d7', component.options)
    } else {
      api.reload('6907f1d7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6907f1d7&scoped=true&", function () {
      api.rerender('6907f1d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/newTemplateMgr/index.vue"
export default component.exports